import { formatPrice } from '@/core/lib/utils/format-price'
import { useTranslations } from 'next-intl'
import { useOrderSummaryStore } from '../../store'

export const OrderDiscount = ({ className = '' }: { className?: string }) => {
  const t = useTranslations()

  const { totalPrice, currency, providerPrice, customerPrice, price } =
    useOrderSummaryStore()

  return (
    <div className={`flex flex-col ${className}`}>
      {customerPrice ? (
        <span className='flex gap-1 text-nowrap' dir='ltr'>
          {t('trip.customerPrice', { ns: '' })}
          <span className='line-through'>
            {formatPrice(customerPrice, currency)}
          </span>
        </span>
      ) : (
        <span
          className='text-grey mr-2 text-sm font-medium line-through'
          dir='ltr'
        >
          {formatPrice(price, currency)}
        </span>
      )}
      {customerPrice ? null : (
        <span className='text-red text-xl font-medium' dir='ltr'>
          {formatPrice(providerPrice || totalPrice, currency)}
        </span>
      )}
    </div>
  )
}
